import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
]

export const protectedRoutes = [
    {
        key: 'home',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    // Kindergartens (bog'chalar) statistics dashboard.
    {
        key: 'bogchalar',
        path: `${APP_PREFIX_PATH}/dashboards/bogchalar`,
        component: React.lazy(() => import('views/app-views/dashboards/bogchalar')),
    },
    // Teachers (o'qituvchilar) statistics dashboard.
    {
        key: 'oqituvchilar',
        path: `${APP_PREFIX_PATH}/dashboards/oqituvchilar`,
        component: React.lazy(() => import('views/app-views/dashboards/oqituvchilar')),
    },
    // Departments 1–4: one reusable page driven by SectionsConfig (ТЗ рек. №1).
    {
        key: 'boshqaruv.section',
        path: `${APP_PREFIX_PATH}/boshqaruv/:deptKey/:subKey`,
        component: React.lazy(() => import('views/app-views/department/DepartmentSectionPage')),
    },
    // Department 5 (statistics module) — strict Excel screens + ranking.
    {
        key: 'talim.section',
        path: `${APP_PREFIX_PATH}/talim/:subKey`,
        component: React.lazy(() => import('views/app-views/talim')),
    },
    // Davomat (attendance) — statistics + detailed table.
    {
        key: 'davomat.section',
        path: `${APP_PREFIX_PATH}/davomat/:subKey`,
        component: React.lazy(() => import('views/app-views/davomat')),
    },
    // Demo settings (regenerate / clear data).
    {
        key: 'sozlamalar',
        path: `${APP_PREFIX_PATH}/sozlamalar`,
        component: React.lazy(() => import('views/app-views/settings')),
    },
]
